import {
    HttpResponse,
    WalletTransactionModel,
    QueryModel,
    RequestParams,
    WalletTransactionModelIEnumerableApiResultSuccess,
    WalletTransactionModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class WalletTransactionsDataService implements CrudService<WalletTransactionModel, WalletTransactionModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getWalletTransactionGroupped(query, params);
    }
    
    getAll(query: CrudDataQuery<WalletTransactionModel>): Promise<CrudListResponse<WalletTransactionModel>> {
        return ApiService.api.getWalletTransactionBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<WalletTransactionModel>> {
        return ApiService.api.getWalletTransactionById(id, params);
    }

    create(item: WalletTransactionModel, params?: RequestParams): Promise<CrudResponse<WalletTransactionModel>> {
        return ApiService.api.insertWalletTransaction(item, params);
    }

    update(item: WalletTransactionModel, params?: RequestParams): Promise<WalletTransactionModel> {
        return ApiService.api.updateWalletTransaction(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<WalletTransactionModel> {
        return ApiService.api.patchWalletTransaction(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<WalletTransactionModel>): Promise<CrudListResponse<WalletTransactionModel>> {
        return ApiService.api.deleteWalletTransaction(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<WalletTransactionModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
